<template>
  <v-container class="view">
    <v-row justify="center" align="center" style="min-height:50vh">

      <v-col cols="12" sm="4">
        <h2 class="text-capitalize text-center display-5 mt-3">
          Create new password
        </h2>
        <!------------------------show login error or ask user to login----------------->
        <p v-if="error" class="red--text lighten-3 px-2 text-small text-center" v-html="error"></p>

        <p v-else class="text-center mb-3 sub-hero-text sub-hero-text text-capitalize">
          password must have at least 8 characters
        </p>

        <!--------------login form ----------------->
        <v-form v-model="valid" @submit.prevent="submit" lazy-validation ref="form">
          <v-text-field class="m-0 p-0" autocomplete="current-password" :value="userPassword" label=" New Password"
            outlined required v-model="password" type="password"></v-text-field>

          <v-text-field class="m-0 p-0" autocomplete="current-password" :value="userPassword" label="Confirm Password"
            outlined required v-model="confirmPassword" type="password"></v-text-field>

          <!----------------send--------------------->
          <v-btn block type="submit" class="white--text" large color="var(--purple)" :loading="loading"
            :disabled="loading">
            Reset
          </v-btn>
          <small class="grey-text">
            Back to <router-link to="login">Login</router-link></small>
        </v-form>
        <!--snackbar for messages-->
        <v-snackbar v-model="snackbar" text :color="error ? 'var(--red)' : 'success'" elevation="1" :timeout="timeout">
          {{ errorMessage }}
          <template v-slot:action="{ attrs }">
            <v-btn :color="error ? 'var(--pink)' : 'success'" text v-bind="attrs" @click="snackbar = false">
              Close
            </v-btn>
          </template>
        </v-snackbar>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import axios from "axios";
export default {
  data: () => ({
    confirmPassword: "",
    password: "",
    valid: false,
    loading: false,
    error: null,
    userPassword: "",
    value: true,
    snackbar: false,
    passwordValidationRules: [
      (v) => v.length > 0 || "Password must be provided",
    ],
  }),

  methods: {
    async submit() {
      try {
        const { password, confirmPassword } = this;
        //validate the payload
        if (!this.$refs.form.valdate()) {
          return;
        }

        if (password !== confirmPassword) {
          this.errorMessage = "Passwords do not match";
          return;
        }

        const { data: response } = await axios.post("/auth/set-new-apssword")
        console.log(response)
      } catch (error) {
        this.loading = false
        this.error = true
        this.errorMessage = error.response.data.message;
        this.snackbar = true;
        this.response = error.response.data;
      }
    },
  },
};
</script>

<style scoped>
.no-border {
  border: none;
}
</style>